import { render, staticRenderFns } from "./DocumentsAndData.vue?vue&type=template&id=91b3a8e2&"
import script from "./DocumentsAndData.vue?vue&type=script&lang=js&"
export * from "./DocumentsAndData.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsAndData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports